module.exports = __webpack_public_path__ + "static/media/logo-dark.81fce5aa.png";